'use server'

import { apiRequest, ApiResponse } from '../request'

export type UrgentAlertKey = 'whatsapp_disconnected' | 'ai_credits_exhausted'

export interface UrgentAlert {
    key: UrgentAlertKey
    severity: 'error' | 'warning'
    message: string
    actionLabel: string
    href: string
}

/** Evento de socket: as ações urgentes mudaram, buscar de novo. */
export const URGENT_ALERTS_CHANGED_EVENT = 'urgent-alerts-changed'

export async function getUrgentAlerts(): Promise<ApiResponse<UrgentAlert[]>> {
    return apiRequest<UrgentAlert[]>('urgent-alerts', {})
}
